import React from "react";
import ReactECharts from "echarts-for-react";

const SunburstChart = (props) => {
  // console.log(props.data);
  const data = props.data;

  const option = {
    series: {
      type: "sunburst",
      data: data,
      radius: [0, "70%"],
      label: {
        rotate: "radial",
        color: "#FFFFFF",
      },
      labelLayout: function() {
        return {
          moveOverlap: "shiftY",
          align: "center",
          verticalAlign: "center",
          rotate: 0,
        };
      },
      levels: [
        {},
        {
          labelLayout: function() {
            return {
              moveOverlap: "shiftY",
              align: "center",
              verticalAlign: "center",
              rotate: 0,
            };
          },
        },
        {},
        {
          label: {
            position: "outside",
            distance: 50,
            fontWeight: "lighter",
            color: "#FFFFFF",
            backgroundColor: "#0F3E6E",
          },
          labelLine: {
            show: true,
            width: 3,
          },
        },
      ],
    },
    tooltip: {
      trigger: 'item',
      formatter: function(params) {
          let totalStudents = 0;
          let parentData = params.treePathInfo.length > 1 ? params.treePathInfo[params.treePathInfo.length - 2].data : null;

          if (parentData && parentData.children) {
              for (const child of parentData.children) {
                  totalStudents += child.value;
              }
          }

          let percentage = 100
          if (params.treePathInfo.length > 2) {
            let totalForPerc = params.treePathInfo[params.treePathInfo.length - 2].value
            percentage = totalForPerc !== 0 ? ((params.data.value / totalForPerc) * 100).toFixed(2) : 0;
          }

          let hierarchy = params.treePathInfo.map(info => info.name).join('/');
          if (hierarchy.startsWith('/')) {
              hierarchy = hierarchy.slice(1);
          }

          let tooltipStr = `<b>${hierarchy}</b><br>`;
          tooltipStr += `Subgroup: <b>${props.subgroup}</b><br>`;
        tooltipStr += `Number of Students: <b>${params.data.value > 10 ? params.data.value.toLocaleString() : '*'}</b><br>`;
        tooltipStr += `Percentage: <b>${percentage}%</b>`;
        if (params.data.value < 11) {
          tooltipStr += `<br>* represents less than 11 students`;
        }


          return tooltipStr;
      },
      padding: 10,
      borderWidth: 1,
      borderRadius: 8
    }
  };

  return <ReactECharts option={option} style={{ height: "500px" }} />;
};

export default SunburstChart;
